import { Button } from "@/shared/ui/button.tsx";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose
} from "@/shared/ui/dialog.tsx"
import { CheckCircle, Undo2 } from "lucide-react";
import { useAddMultiPlatform, useSaveImageTheme, useSchedulePost } from "../api";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";
import { useEffect } from "react";
import { Platform } from "../types";
import { toast } from "sonner";


type ConfirmScheduleDialogProps = {
  trigger: JSX.Element,
  post_id: number,
  event_id: number,
  story_id: number | null,
  image_id: number,
  onSchedule: (text: string) => void,
  image_ids: string[] | null,
  platform: string,
  platformSelected: Platform[],
  otherPlatforms: string[]
}

const ConfirmScheduleDialog = ({ trigger, post_id, story_id, event_id, image_id ,onSchedule, platform, platformSelected, otherPlatforms, image_ids }: ConfirmScheduleDialogProps) => {

  const { schedulePost } = useSchedulePost(onSchedule)

  const { saveImage } = useSaveImageTheme()

  const theme = useAtomValue(themeAtom)

  const { addPlatforms, isSuccess, posts } = useAddMultiPlatform()

  useEffect(() => {
    const scheduleAllPosts = async(postIds: number[]) => {
      console.log(postIds)
      await Promise.all(postIds.map(id => schedulePost({ postId: id, img_ids: image_ids })))
    }
    if(isSuccess && posts){
      try {
        scheduleAllPosts(posts.new_post_ids)
      } catch (error) {
        toast.message("Something went wrong, please try again")
      }
    }
  }, [isSuccess])

  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[455px] border-4 border-purple-400 rounded-2xl">
        <DialogHeader>
          <DialogTitle className="w-full text-center font-montserrat">Schedule post</DialogTitle>
        </DialogHeader>
        <div className="w-full flex flex-col gap-2">
          <p className="text-gray-600 text-sm font-poppins tracking-wide">Looks good! Should we post this on {platform}{otherPlatforms.length > 0 && ", "}{otherPlatforms.map(( item, index ) => `${item} ${index < otherPlatforms.length -1 ? ", " : ""}`)}</p>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" variant="outline" style={{ borderColor: theme.secondary }} className="flex items-center gap-2 rounded-xl border-2">Make changes <Undo2 /></Button>
          </DialogClose>
          <DialogClose asChild>
            <Button
              variant="outline"
              type="button"
              onClick={() => {
                if(platformSelected.length > 0){
                  const platformsList: string[] = platformSelected.map(data => data.name)
                  addPlatforms({ post_id, platforms: platformsList })
                }
                if(image_ids === null){
                  saveImage({
                    story_id: story_id === null ? 0 : story_id,
                    event_id: event_id,
                    image_id: image_id
                  })
                }
                schedulePost({postId: post_id, img_ids: image_ids})
              }}
              className="flex items-center gap-2 rounded-xl border-2 border-purple-400">
              Yes Schedule <CheckCircle />

            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmScheduleDialog;
